'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of yield
 */ const Yield = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M79.4505 68.9549L79.4485 68.9513L53.7394 24.6814C53.2366 23.8134 52.4078 23.7191 52.0749 23.7188H52.0732C51.738 23.7188 50.9079 23.8131 50.4027 24.6821L24.6914 68.9549C24.1836 69.8243 24.5185 70.596 24.6861 70.8875C25.0361 71.4967 25.6632 71.8591 26.3645 71.8591H26.377L52.0739 71.6879H52.0837L77.7662 71.8591H77.7777C78.479 71.8591 79.1057 71.4967 79.4557 70.8879C79.6233 70.596 79.9585 69.8243 79.4505 68.9549Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "48.1758",
                y: "35.0762",
                width: "6.84669",
                height: "23.4592",
                rx: "3.42334",
                transform: "rotate(-0.171913 48.1758 35.0762)",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "51.6332",
                cy: "63.5949",
                r: "3.44708",
                transform: "rotate(-0.171913 51.6332 63.5949)",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M84.9512 65.9513L58.7246 21.6177C55.7307 16.5571 48.4123 16.5571 45.4188 21.6177L19.1974 65.9513C16.1502 71.1026 19.8655 77.6117 25.8477 77.6117H78.2957C84.2828 77.6117 87.9985 71.0974 84.9512 65.9513ZM82.0923 72.2561C81.6694 72.9887 81.0651 73.6033 80.3454 74.033C79.5884 74.4847 78.715 74.7229 77.8175 74.7229H77.7859L52.0773 74.5521L26.3631 74.7229C25.4548 74.7291 24.5691 74.4899 23.8036 74.033C23.0835 73.6033 22.4796 72.9887 22.0564 72.2557C21.1625 70.7065 21.1681 68.8619 22.0712 67.3202L47.8163 23.1583C48.7108 21.6259 50.3031 20.7116 52.0763 20.7116H52.0809C53.8535 20.7133 55.4431 21.6285 56.3336 23.16L82.0761 67.3173C82.9809 68.8596 82.9868 70.7059 82.0923 72.2561Z",
                fill: theme.ds5.asset[assetColor]["100"]
            })
        ]
    });
};

exports.Yield = Yield;
//# sourceMappingURL=Yield.cjs.map
